// Generated with util/create-component.js
import Foot from './Foot';

export default Foot;
